//======================================================================================================
//
// This store houses the toast event message's throughout the application.
//
//======================================================================================================

import { defineStore } from "pinia";
import { mount } from "mount-vue-component";
import Toast from "../components/additional_components/toast.vue";

export const useToastStore = defineStore("toastStore", {
	actions: {
		toast: (options: {
			message: string;
			title: string;
			type: string;
			dismissable: boolean;
		}) => {
			//vNode, destroy,
			const { el } = mount(Toast, {
				props: {
					title: options.title,
					message: options.message,
					type: options.type,
					dismissable: options.dismissable
				}
			});
			const body: any = document.getElementById("toast-container");
			body.appendChild(el.childNodes[0]);
		}
	}
});
